// ParticleField — スキャンライン統一に伴い無効化
export function ParticleField(): null {
  return null;
}
